import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Table, Col, Form, Row } from "react-bootstrap";
import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import DynamicPagination from "../../components/DynamicPagination ";
import { useNavigate } from "react-router-dom";

function SkuSearchPopUp({ show, setShow, autoId, vendorName }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [fetchedData, setFetchedData] = useState(null);

  const [searchDebounce, setSearchDebounce] = useState({
    search: "",
    type: "",
  });

  const handleSearch = (e) => {
    setSearchDebounce((p) => ({ ...p, search: e.target.value }));
    setPage(1);
  };

  const navigate = useNavigate();

  const handleTypeFilter = (e) => {
    setSearchDebounce((p) => ({ ...p, type: e.target.value }));
    setPage(1);
  };

  const { debounceSearch } = useDebounce(searchDebounce);

  const { postData: fetchVendorProducts, data } = usePostRequest(
    API_ENDPOINTS.GET_VENDOR_PRODUCTS
  );

  useEffect(() => {
    if (!autoId) return;
    fetchVendorProducts({
      page,
      limit,
      auto_id: autoId,
      type: searchDebounce?.type || null,
      search: searchDebounce?.search?.length > 0 ? searchDebounce.search : null,
    });
  }, [page, limit, searchDebounce, autoId]);

  useEffect(() => {
    if (data && data.data) setFetchedData(data);
  }, [data]);

  const handlePageChange = (nextPage) => setPage(nextPage);
  const handleLimitChange = (selectedLimit) => {
    setLimit(selectedLimit);
    setPage(1);
  };

  const handleCloseModal = () => {
    setShow(false);
    setSearchDebounce({ search: "", type: "" });
    setFetchedData(null);
    setPage(1);
  };

  const goToProduct = (product) => {
    const skuId = product?.sku_id;
    handleCloseModal();
    navigate(`/products-list?${skuId}`);
  };

  return (
    <Modal
      scrollable={true}
      show={show}
      onHide={handleCloseModal}
      className="skusearch"
      dialogClassName="modal-90vw"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Row className="w-100">
          <Col className="mb-3">
            <Form.Control
              type="text"
              placeholder="Search"
              autoComplete="off"
              value={searchDebounce.search}
              onChange={handleSearch}
            />
          </Col>
          <Col className="mb-3">
            <Form.Select value={searchDebounce.type} onChange={handleTypeFilter}>
              <option value="">All Types</option>
              <option value="inventory">Inventory</option>
              <option value="non-inventory">Non-Inventory</option>
              <option value="kit">Kit</option>
            </Form.Select>
          </Col>
        </Row>
      </Modal.Header>

      <Modal.Body className="vh-100">
        <div className="table-responsive">
          <Table>
            <thead responsive>
              <tr>
                <th className="">VENDOR</th>
                <th className="">SKU</th>
                <th className="">PRODUCT NAME</th>
                <th className="">TYPE</th>
                <th className="">DESCRIPTION</th>
              </tr>
            </thead>
            <tbody>
              {fetchedData &&
                fetchedData?.data?.map((product, index) => (
                  <tr key={index} onClick={() => goToProduct(product)} style={{ cursor: "pointer" }}>
                    <td className="text-start">
                      {vendorName}
                    </td>
                    <td className="text-start text-orange">
                      {product?.sku_display_name}
                    </td>
                    <td className="text-start text-orange">{product?.name}</td>
                    <td className="text-start">
                      {{
                        kit: "Kit",
                        "non-inventory": "Non-Inventory",
                        inventory: "Inventory",
                      }[product?.type] || ""}
                    </td>
                    <td className="text-start">
                      {product?.description_sales
                        ? product.description_sales.length > 100
                          ? product.description_sales.slice(0, 100) + "..."
                          : product.description_sales
                        : ""}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>

        {data?.data?.length > 0 ? (
          <DynamicPagination
            totalPages={data?.pagination?.totalPages}
            currentPage={page}
            onPageChange={handlePageChange}
            limitPerPage={limit}
            onLimitChange={handleLimitChange}
          />
        ) : (
          <p className="text-center mt-2">No matching records found.</p>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default SkuSearchPopUp;